// Dependencies
import Sources from '../components/Sources';

function SourcesPage()
{
    return(
        <Sources />
    );
}

export default SourcesPage;